<template>
  <div :id="'chartLine' + index" class="chart"></div>
</template>

<script>
  export default {
    props: ["index", "factorId", "star"],
    data() {
      return {
        chartData: [],
        chartDate: [],
        themeStyleVs: "",
      };
    },
    mounted() {
      this.token = this.$route.query.token;
      this.themeStyleVs = this.$route.query.themeStyleVs;
      this.getChartLine(this.factorId);
      // this.drawLine()
    },
    methods: {
      // 获取折线数据
      getChartLine(factorId) {
        var postParam = {
          qid: new Date().getTime(),
          param: {
            factorId,
          },
        };
        this.$http({
          method: "post",
          url:
            window.config.research_server +
            "/research-framework-server/rf/fm/idx/fvs",
          data: postParam,
          headers: {
            token: this.token,
          },
        }).then((res) => {
          var result = [];
          var newResult = [];
          if (res.data?.data?.length > 0) {
            result = res.data.data;
            result.forEach((element) => {
              if (element.v != "" && element.v != undefined) {
                newResult.push(element);
              }
            });
            newResult.forEach((element) => {
              this.chartDate.push(element.t);
              this.chartData.push(element.v);
            });
            this.drawLine();
          }
        });
      },
      drawLine() {
        if (document.getElementById("chartLine" + this.index)) {
          var chartLine = this.$echarts.init(
            document.getElementById("chartLine" + this.index)
          );
          var areaColorR1 =
            this.themeStyleVs == 1
              ? "rgba(241, 73, 87, 0.3)"
              : "rgba(219, 69, 82, 0.30)";
          var areaColorR2 =
            this.themeStyleVs == 1
              ? "rgba(241, 73, 87, 0)"
              : "rgba(219, 69, 82, 0)";
          var areaColorG1 =
            this.themeStyleVs == 1
              ? "rgba(11, 175, 128, 0.3)"
              : "rgba(11, 175, 128, 0.30)";
          var areaColorG2 =
            this.themeStyleVs == 1
              ? "rgba(11, 175, 128, 0)"
              : "rgba(11, 175, 128, 0)";
          var option = {
            grid: {
              top: 0,
              bottom: 0,
              left: 0,
              right: 0,
            },
            xAxis: {
              type: "category",
              data: this.chartDate,
              show: false,
            },
            yAxis: {
              type: "value",
              show: false,
              splitLine: {
                show: false,
              },
              max: "dataMax",
              min: "dataMin",
            },
            series: [
              {
                data: this.chartData,
                type: "line",
                symbolSize: 0,
                areaStyle: {
                  color: this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    {
                      offset: 0,
                      color: this.star > 0 ? areaColorR1 : areaColorG1,
                    },
                    {
                      offset: 1,
                      color: this.star > 0 ? areaColorR2 : areaColorG2,
                    },
                  ]),
                },
                lineStyle: {
                  width: 2,
                  color:
                    this.star > 0
                      ? "rgba(241, 73, 87, 1)"
                      : "rgba(11, 175, 128, 1)",
                },
              },
            ],
          };
          chartLine.setOption(option);
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .chart {
    width: 100%;
    height: 100%;
  }
</style>
